import type { ComponentPropsWithRef, ReactNode } from 'react'

export interface CardProps extends ComponentPropsWithRef<'div'> {
  children: ReactNode
}

export function Card({ children, className = '', ...props }: CardProps) {
  return (
    <div
      {...props}
      className={`bg-surface-raised border-border rounded-(--radius-card) border p-5 ${className}`}
    >
      {children}
    </div>
  )
}
